/** @jsxImportSource @emotion/react */
import {
    Restaurant, LocalBar, LocalCafe, LocalPizza, LunchDining,
    BakeryDining, RamenDining, Icecream, Cake, SetMeal,
    Tapas, SoupKitchen, KebabDining, LocalDining,
    WineBar, EmojiFoodBeverage, DinnerDining, BrunchDining,
    EggAlt, RiceBowl, LocalFlorist, Fastfood,
    Church, Celebration, Favorite, FavoriteBorder, Diamond,
    Groups, MusicNote, PhotoCamera, CameraAlt, DirectionsCar,
    Park, Nightlife, SportsBar, CardGiftcard,
    Checkroom, TheaterComedy, Spa, FilterVintage, AutoAwesome,
    Stars, EmojiPeople, DirectionsWalk, Schedule, Place,
    NightlightRound
} from "@mui/icons-material"
import { Interpolation, Theme } from "@emotion/react"

const ICON_MAP: Record<string, React.ComponentType<any>> = {
    Restaurant, LocalBar, LocalCafe, LocalPizza, LunchDining,
    BakeryDining, RamenDining, Icecream, Cake, SetMeal,
    Tapas, SoupKitchen, KebabDining, LocalDining,
    WineBar, EmojiFoodBeverage, DinnerDining, BrunchDining,
    EggAlt, RiceBowl, LocalFlorist, Fastfood,
    Church, Celebration, Favorite, FavoriteBorder, Diamond,
    Groups, MusicNote, PhotoCamera, CameraAlt, DirectionsCar,
    Park, Nightlife, SportsBar, CardGiftcard,
    Checkroom, TheaterComedy, Spa, FilterVintage, AutoAwesome,
    Stars, EmojiPeople, DirectionsWalk, Schedule, Place,
    NightlightRound
}

export const resolveIcon = (
    iconType: string,
    iconValue: string,
    cssStyle?: Interpolation<Theme>
): React.ReactNode => {
    if (iconType === 'emoji') {
        return <span>{iconValue}</span>
    }

    const IconComponent = ICON_MAP[iconValue]
    if (IconComponent) {
        return <IconComponent css={cssStyle} />
    }

    return <Restaurant css={cssStyle} />
}
